export default "__VITE_ASSET__CbKFs1pa__"